import Box from "@mui/material/Box";
import CloudOffIcon from "@mui/icons-material/CloudOff";
import React, { FunctionComponent } from "react";
import Button from "../button/Button";
import Placeholder from "./Placeholder";

export interface RequestErrorPlaceholderProps {
	/**
	 * Localization resource to display a button text
	 * @defaultValue Retry
	 */
	buttonRes?: string;

	/** callback function to be called when the button is clicked */
	onRetry: () => void;

	/** indicates if retry button should be secondary rather than primary */
	secondary?: boolean;

	/**
	 * Localization resource to display a subtitle text
	 * @defaultValue RequestErrorMessage
	 */
	subtitleRes?: string;

	/** parameters to pass if looking up resource */
	subtitleResParams?: Array<number | string>;

	/**
	 * Localization resource to display a title text
	 * @defaultValue RequestError
	 */
	titleRes?: string;

	/** parameters to pass if looking up resource */
	titleResParams?: Array<number | string>;
}

const RequestErrorPlaceholder: FunctionComponent<RequestErrorPlaceholderProps> = (props) => {
	const { buttonRes, onRetry, secondary, subtitleRes, subtitleResParams, titleRes, titleResParams } = props;

	return (
		<Placeholder
			subtitleProps={{ res: subtitleRes || "RequestErrorMessage", resParams: subtitleResParams }}
			titleProps={{ res: titleRes || "RequestError", resParams: titleResParams }}
		>
			{{
				image:
					<Box color="grey.100" height={72}>
						<CloudOffIcon style={{ fontSize: 72 }} />
					</Box>,

				actions:
					<Button
						design={secondary ? "secondary" : "primary"}
						onClick={onRetry}
						res={buttonRes || "Retry"}
					/>,
			}}
		</Placeholder>
	);
};

export default RequestErrorPlaceholder;